import { useState } from "react";
import ServiceDeliverProduct from "./ServiceDeliverProduct";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function ModalServiceDelivery(props) {
    const { serviceInfo, checkedIn, setServiceInfo, sendSMSToCustomer, popData, setPopData } = props;
    return (
        <Modal show={popData?.show ?? false}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faSignOutAlt} size="lg"/>&nbsp; تحویل به مشتری
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={()=>setPopData({show:false})}/>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <ServiceDeliverProduct serviceInfo={serviceInfo} checkedIn={checkedIn} setServiceInfo={setServiceInfo} sendSMSToCustomer={sendSMSToCustomer} fromModal={true}/>
            </Modal.Body>
        </Modal>
    )
}